module.exports = __webpack_public_path__ + "static/media/icon-search.a40809ae.svg";